import { useContext } from 'react'
import { CustomLayoutContext } from '~/components/layout/Layout'

export const useCustomLayout = () => useContext(CustomLayoutContext)
